import React from 'react'
import { Entry } from 'contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { InboundCTA, IProps as IInboundCTA } from 'marketing-site/src/library/elements/InboundCTA'
import { IInboundCta as IContentfulInboundCTA } from 'marketing-site/@types/generated/contentful'
import { transformCTAWithBackground } from './ContentfulCTALink'

export const ContentfulInboundCTA = (inboundCta: IContentfulInboundCTA) => (
  <EntryMarker entry={inboundCta}>
    {() => <InboundCTA {...transformInboundCTA(inboundCta)} />}
  </EntryMarker>
)

export function isInboundCTA(entry: Entry<any>): entry is IContentfulInboundCTA {
  return entry.sys.contentType?.sys.id === 'inboundCta'
}

export function transformInboundCTA({ fields }: IContentfulInboundCTA): IInboundCTA {
  return {
    cta: transformCTAWithBackground(fields.cta),
  }
}
